// 버전 문자열(예: "1.0.30")을 숫자 단위로 비교
// a < b 이면 음수, a === b 이면 0, a > b 이면 양수 반환
export const compareVersion = (a, b) => {
    const pa = String(a).split(".").map(Number);
    const pb = String(b).split(".").map(Number);
    const len = Math.max(pa.length, pb.length);

    for (let i = 0; i < len; i++) {
        const na = pa[i] || 0;
        const nb = pb[i] || 0;
        if (na !== nb) return na - nb;
    }
    return 0;
};

// version이 target 미만이면 true (version 미주입 시에도 true)
export const isBelowVersion = (version, target) => {
    if (!version) return true;
    return compareVersion(version, target) < 0;
};
